import * as productsActions from '../actions/products.actions';
import { setActiveCompany } from '@core/auth/@store/user/user.actions';
import { ProductModel } from 'app/models/product-api.model';
import { createReducer, on, Action } from '@ngrx/store';

export interface State {
  products: ProductModel[];
  totalProducts: number;
  isLoading: boolean;
  isReady: boolean;
  isSaving: boolean;
}

export const initialState: State = {
  products: [],
  totalProducts: 0,
  isLoading: false,
  isReady: false,
  isSaving: false,
};

const featureReducer = createReducer(
  initialState,
  on(productsActions.loadProducts, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(productsActions.loadProductsSuccess, (state: State, { response }) => ({
    ...state,
    isLoading: false,
    isReady: true,
    products: response.results,
    totalProducts: response.count,
  })),
  on(productsActions.createProduct, productsActions.updateProduct, (state) => ({
    ...state,
    isSaving: true,
  })),
  on(
    productsActions.createProductSuccess,
    productsActions.createProductFailed,
    productsActions.updateProductSuccess,
    productsActions.updateProductFailed,
    (state) => ({
      ...state,
      isSaving: false,
    })
  ),
  on(
    productsActions.resetProducts,
    setActiveCompany,
    (state: State) => initialState
  )
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
